import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  dialogClose: {
    marginLeft: 'auto',
    color: theme.palette.colors.border,
    fontSize: 32,
  },
  closeContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    padding: 15,
  },
  selectionBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.up('mobile')]: {
      minWidth: 350,
    },
  },
  selectionHeader: {
    fontSize: '1.2rem',
    marginBottom: [theme.spacing(5)],
  },
  button: {
    width: '100%',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up('mobile')]: {
      width: 300,
    },
  },
  buttonSecondary: {
    width: '100%',
    marginBottom: theme.spacing(3),
    color: theme.palette.colors.teal,
    borderColor: theme.palette.colors.teal,
    '&:hover': {
      borderColor: theme.palette.colors.teal,
    },
    [theme.breakpoints.up('mobile')]: {
      width: 300,
    },
  },
  header: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    marginBottom: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
  },
  back: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    padding: theme.spacing(2),
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  backButton: {
    padding: 3,
    paddingRight: 0,
    display: 'flex',
    justifyContent: 'end',
  },
  avatar: {
    width: 64,
    height: 64,
    borderRadius: 10,
  },
  avatarContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    padding: 10,
  },
}));



// WEBPACK FOOTER //
// ./src/components/SignUp/useStyles.js